module.exports = __webpack_public_path__ + "dataLink.b6fff24c.jpg";